import { Component, Input, OnInit } from "@angular/core";
import { TabConfigStructure } from "../../config/tab-config-structure";
import { AppUtils } from "../../shared/app-utils";
import { Property } from "../../shared/property/property.model";
import { ObjectDetailTitle } from "../../search/search-list/results/result-item/object-detail-title.model";
import { PublicDataViewService } from "../public-data-view.service";
import { AppConfigService } from "../../config/app-config.service";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-public-data-view-details",
  templateUrl: "./public-data-view-details.component.html",
  styleUrls: ["./public-data-view-details.component.scss"],
})
export class PublicDataViewDetailsComponent implements OnInit {
  @Input() publicDataSet: any;
  @Input() detailPage: boolean;
  @Input() changeTitle: boolean = false;

  properties: Property[];
  title: Property;
  titleWrapper = new ObjectDetailTitle({
    authors: [],
    title: null,
    extras: [],
  });
  sourceLink: string;

  constructor(
    private publicDataViewService: PublicDataViewService,
    private appConfig: AppConfigService,
    private titleService: Title,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: { id: string }) => {
      if (params && params.id && !this.publicDataSet) {
        this.getPublicDatasetRecord(params.id);
      } else {
        if (this.publicDataSet) {
          this.preparePublicDatasetObject(this.publicDataSet);
        }
      }
    });
  }

  getPublicDatasetRecord(id: string) {
    this.publicDataViewService.getData(id).subscribe((data) => {
      this.preparePublicDatasetObject(data);
    });
  }

  preparePublicDatasetObject(data) {
    this.properties = AppUtils.mapObjectToProperties(data);

    this.titleWrapper = AppUtils.createTitleWrapper(data);

    this.sourceLink = data["public_dataset_source_link"];

    if (this.changeTitle) {
      this.titleService.setTitle("Omnis - " + this.titleWrapper.title.label);
    }
  }

  getConfig(): TabConfigStructure[] {
    return this.appConfig.publicDatasetConfig.publicDatasetConfig;
  }

  openSourceLink() {
    if (this.sourceLink) {
      window.open(this.sourceLink, "_blank");
    }
  }
}
